module.exports = __webpack_public_path__ + "static/media/delete.792c5095.svg";